module.exports = "<h1>Counter</h1>\r\n\r\n<p>This is a simple example of an Angular component.</p>\r\n\r\n<p>Current count: <strong>{{ currentCount }}</strong></p>\r\n\r\n<button (click)=\"incrementCounter()\">Increment</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/counter/counter.component.html
// module id = 20
// module chunks = 0